import { s as script } from './Input-0ivJhXUC.js';
import { a as registerComponent } from './plugins-C7548x21.js';
import './Icon-fJqkx1gN.js';
import './config-nHWiBviw.js';
import './helpers-O9h6_ICO.js';
import './typeof-Z4rCTFCZ.js';
import 'vue';
import './CompatFallthroughMixin-Ev2XGfi3.js';
import './FormElementMixin-ILDlgM3i.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, script);
  }
};

export { script as BInput, Plugin as default };
